<ng-container *ngIf="currentUserWrapper$ | async as currentUserWrapper">
  <div
    [viewportOptions]="{
      verticalTolerance: 200,
      horizontalTolerance: 10,
      shouldCheckHorizontal: false
    }"
    (visibilityChange)="onVisibilityChange($event)"
    astrobinScrollVisibility
  >
    <ng-container *ngIf="!initialLoading && results !== null; else loadingTemplate">
      <ng-container *ngIf="results.length > 0; else noImagesTemplate">
        <!-- Selected Users Display -->
        <div *ngIf="selectedUsers && selectedUsers.length > 0" class="selected-users-container">
          <h3 class="selected-users-title">{{ "Showing images from" | translate }}</h3>
          <div class="selected-users-row">
            <div *ngFor="let user of selectedUsers" class="selected-user-card">
              <a
                [href]="
                  userService.getGalleryUrl(
                    user.username,
                    !currentUserWrapper.userProfile || currentUserWrapper.userProfile.enableNewGalleryExperience
                  )
                "
                (click)="navigateToUserGallery($event, user)"
                class="user-link"
                astrobinEventPreventDefault
              >
                <img
                  [alt]="user.displayName + ' avatar'"
                  [src]="user.avatar | orDefaultAvatar"
                  class="user-avatar-large"
                />
                <span class="user-display-name">{{ user.displayName }}</span>
              </a>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            (showRetailers && allowFullRetailerIntegration && (itemListings?.length || brandListings?.length)) ||
            (showMarketplaceItems && marketplaceLineItems?.length)
          "
          class="mb-4"
        >
          <div
            *ngIf="allowFullRetailerIntegration && (itemListings?.length || brandListings?.length)"
            class="alert alert-light retailers"
          >
            <ng-container *ngIf="itemListings?.length">
              <div>
                <fa-icon class="me-2" icon="shopping-cart"></fa-icon>
                <span [innerHTML]="itemListings[0] | itemListingMessage" class="me-2"></span>
              </div>
              <div class="list flex-wrap">
                <a *ngFor="let item of itemListings" [href]="item.url" class="link" target="_blank">
                  <img [alt]="item.retailer.name" [src]="item.imageUrl || item.retailer.logo" class="image" />
                  <span *ngIf="item.listingType === EquipmentItemListingType.PAIRS_WELL" class="pairs-well-badge">
                    {{ "Pairs well!" | translate }}
                  </span>
                </a>
              </div>
            </ng-container>

            <ng-container *ngIf="(!itemListings || itemListings.length === 0) && brandListings?.length > 0">
              <div>
                <fa-icon class="me-2" icon="shopping-cart"></fa-icon>
                <span [innerHTML]="brandListings[0].brand | brandListingMessage" class="me-2"></span>
              </div>
              <div class="list flex-wrap">
                <a *ngFor="let item of brandListings" [href]="item.url" class="link" target="_blank">
                  <img [alt]="item.retailer.name" [src]="item.retailer.logo" class="image" />
                </a>
              </div>
            </ng-container>
          </div>

          <div *ngIf="marketplaceLineItems?.length" class="alert alert-light marketplace-listings">
            <div>
              <fa-icon class="me-2" icon="shopping-cart"></fa-icon>
              <span [innerHTML]="marketplaceMessage" class="me-2"></span>
            </div>
            <div class="list flex-wrap">
              <a
                *ngFor="let item of marketplaceLineItems"
                [routerLink]="['/equipment/marketplace/listing', item.listingHash]"
                class="link"
              >
                <img
                  *ngIf="item.images?.length"
                  [alt]="item.itemName"
                  [src]="item.images[0].thumbnailFile"
                  class="image"
                />

                <span *ngIf="!item.images || item.images.length === 0" class="item-name">
                  {{ item.itemName }}
                </span>
              </a>
            </div>
          </div>
        </div>

        <div *ngIf="showResultsCount && lastResultsCount" class="results-count">
          <span [innerHTML]="lastResultsCount"></span>
        </div>

        <astrobin-masonry-layout
          [idProperty]="'objectId'"
          [items]="results"
          [layout]="'medium'"
          [leftAlignLastRow]="next === null"
        >
          <ng-template let-item>
            <div class="image-container">
              <a [href]="'/i/' + (item.hash || item.objectId)" (click)="openImage($event, item)">
                <ng-container *ngIf="imageService.getObjectFit(item) as fit">
                  <div
                    [astrobinLazyBackground]="item.regularThumbnail"
                    [attr.aria-label]="item.title"
                    [highResolutionUrl]="item.hdThumbnail"
                    [ngStyle]="{
                      'background-position': fit.position.x + '% ' + fit.position.y + '%',
                      'background-size': fit.scale > 1.5 ? fit.scale * 100 + '%' : 'cover',
                      'background-repeat': 'no-repeat'
                    }"
                    [useHighResolution]="fit.scale > 3"
                    role="img"
                  ></div>
                </ng-container>

                <astrobin-loading-indicator
                  *ngIf="loadingImageId?.toString() === item?.objectId?.toString()"
                  @fadeInOut
                  class="position-absolute top-0"
                ></astrobin-loading-indicator>

                <astrobin-image-icons [image]="item"></astrobin-image-icons>

                <astrobin-image-hover
                  *ngIf="!loadingImageId && !isMobile && showDynamicOverlay"
                  @fadeInOut
                  [activeLayout]="UserGalleryActiveLayout.MEDIUM"
                  [image]="item"
                  [staticOverlay]="staticOverlay"
                ></astrobin-image-hover>
              </a>
            </div>
          </ng-template>
        </astrobin-masonry-layout>

        <div *ngIf="!loading && !initialLoading && !!next" class="w-100 d-flex justify-content-center mt-4">
          <button (click)="loadMore().subscribe()" class="btn btn-outline-primary btn-no-block">
            {{ "Load more" | translate }}
          </button>
        </div>

        <div *ngIf="!initialLoading && loading" class="mt-4">
          <ng-container *ngIf="loading">
            <astrobin-image-gallery-loading
              [activeLayout]="UserGalleryActiveLayout.MEDIUM"
              [numberOfImages]="25"
            ></astrobin-image-gallery-loading>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #noImagesTemplate>
  <astrobin-nothing-here [withAlert]="false" [withInfoSign]="false"></astrobin-nothing-here>
</ng-template>

<ng-template #loadingTemplate>
  <astrobin-image-gallery-loading
    [activeLayout]="UserGalleryActiveLayout.MEDIUM"
    [numberOfImages]="25"
  ></astrobin-image-gallery-loading>
</ng-template>

<!-- Floating presentation mode button -->
<astrobin-floating-presentation-button
  *ngIf="showFloatingPresentationButton && searchNavigationContext.length > 1"
  [componentId]="componentId"
  [currentImageId]="searchNavigationContext[0]?.imageId"
  [navigationContext]="searchNavigationContext"
></astrobin-floating-presentation-button>
